<template>
  <v-card color="transparent" flat>
    <event-cards
      :events="current"
      :loading="loading"
      :title="title"
    >
    </event-cards>
  </v-card>
</template>

<script>
import moment from 'moment'
import EventCards from '@/components/EventCards'
import MetaInfoBuilder from '@/utils/social'
import { EventDoc } from '@/utils/types'
import {
  VCard
} from 'vuetify/lib'

export default {
  components: {
    VCard,
    EventCards,
  },
  computed: {
    current() {
      return [...this.events, ...this.extra]
        .filter((event) => {
          if (!event.endAt) {
            return true
          }
          return moment()
            .isSameOrBefore(moment(event.endAt.toDate()))
        })
    },
  },
  data: () => ({
    events: [],
    loading: true,
  }),
  metaInfo() {
    return new MetaInfoBuilder()
      .title(this.title)
      .build()
  },
  mounted() {
    let collection = EventDoc.Collection
        .orderBy('createdAt', 'desc')
        .where('archived', '==', false)
        .where('published', '==', true)

    if (this.type !== '') {
      collection = collection.where('type', '==', this.type)
    }

    this.$bind('events', collection)
      .then(() => this.loading = false)
  },
  props: {
    extra: {
      default() {
        return []
      },
      type: Array
    },
    title: String,
    type: {
      default: '',
      type: String,
    },
  },
}
</script>
